export default __webpack_public_path__ + "static/media/fsw_9.6741e17a.png";